module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-icon-rotate.2c8a0d67.png";